<template>
    <div class="transaction-main">
        <div class="main">
            <div class="filter-box">
                <p class="fl label">订单编号</p>
                <input class="fl input-box" v-model="orderNum" placeholder="请输入订单编号"/>
                <button class="filter-button search fl" @click="search">查询</button>
                <button class="filter-button resetting fl" @click="reset">重置</button>
                <div class="clear"></div>
            </div>
            <div class="main-body">
                <el-table
                        :data="tableData"
                        :default-sort="{ prop: 'date', order: 'descending' }"
                        stripe
                        style="width: 97%"
                        class="body-table"
                        :row-style="{ height: '46px' }"
                        :header-cell-style="{ textAlign: 'center' }"
                        :cell-style="{ textAlign: 'center' }"
                >
                    <el-table-column prop="blanketOrderNum" label="订单编号"></el-table-column>
                    <el-table-column prop="childOrderNum" label="子订单编号"></el-table-column>
                    <el-table-column prop="remarkCode" label="订单编码"></el-table-column>

                    <el-table-column prop="createTime" label="下单时间">
                        <template slot-scope="scope">
                            {{scope.row.createTime | date}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="订单金额">
                        <template slot-scope="scope">
                            {{scope.row.amount | price}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="reciver" label="收货人"></el-table-column>
                    <el-table-column prop="mobile" label="收货电话"></el-table-column>
                    <el-table-column prop="status" label="订单状态">
                        <template slot-scope="scope">
                            <button class="pay-button pointer" v-if="scope.row.payStatus === 0"
                            @click="showPayWindow(scope.row)">待付款</button>
                            <span v-else>已付款</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="edit" label="操作">
                        <template slot-scope="scope">
                            <a @click="toToDetail(scope.row.blanketOrderNum)" class="refund pointer">查看订单</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="main-bottom">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        class="fenye"
                        @current-change="current_change"
                >
                </el-pagination>
            </div>
        </div>
        <div class="pay-model" v-show="payModel" v-loading="loading">
            <div class="mask" @click="payModel = false"></div>
            <div class="pay-box">
                <img class="icon" src="@/assets/shop/warning-icon.png">
                <p class="text-center text">确定将订单状态修改成已付款吗？<br>该操作不可撤销</p>
                <div class="button-box" align="center">
                    <button class="cancel" @click="payModel = false">取消</button>
                    <button class="confirm" @click="payOrder">确认</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {getPublicTransferOrder, confirmReceipt} from '@/api/shop.js'

  export default {
    name: "corporateTransfer",
    data() {
      return {
        date: '',
        tableData: [],
        orderNum: '',
        pageSize: 10, //每页的数据条数
        currentPage: 1, //默认开始页面
        istag: true,
        total: 0,
        orderInfo: {},
        payModel: false,
        loading: false
      };
    },

    mounted() {
      this.total = this.tableData.length;
      this.getOrderList();
    },
    methods: {
      toToDetail(orderId) {
        this.$store.state.isTable = false;
        this.$router.push({
          path: '/orderDetail',
          query: {
            orderId: orderId
          }
        })
      },
      current_change: function (currentPage) {
        this.currentPage = currentPage;
        this.getOrderList()
      },
      search() {
        this.getOrderList()
      },
      reset() {
        this.currentPage = 1;
        this.orderNum = '';
        this.getOrderList()
      },
      getOrderList() {
        let data = {
          length: this.pageSize,
          page: this.currentPage,
        };
        if (this.orderNum) {
          data.orderNum = this.orderNum;
        }
        getPublicTransferOrder(data).then(res => {
          const {transferOrderList, size} = res.data;
          console.log(transferOrderList)
          this.total = size;
          this.tableData = transferOrderList;
          console.log(res.data)
        })
      },
      showPayWindow(orderInfo){
        this.orderInfo = orderInfo;
        this.payModel = true;
      },

      payOrder(){
        this.loading = true;
        const orderId = this.orderInfo.blanketOrderNum;
        confirmReceipt(orderId).then(res => {
          this.loading = false;
          if(res.code === 1){
            this.tableData.map(item => {
              if(orderId === item.blanketOrderNum){
                item.payStatus = 1
              }
              return item;
            })
          }
          this.payModel = false;
        })
      }
    }
  };
</script>

<style scoped lang="scss">
    @import "~@/css/order.scss";
    .pay-button{
        width: 68px;
        height: 30px;
        background:#5189F7;
        border-radius: 2px;
        color: #FFFFFF;
        font-size: 14px;
    }
    .pay-model{
        z-index: 999;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0,0,0,0.4);
        .mask{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 100;
        }
        .pay-box{
            z-index: 200;
            width: 478px;
            height: 248px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            opacity: 1;
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
            top: calc(50% - 124px);
            .icon{
                margin: 46px 215px 0;
                height: 48px;
                width: 48px;
            }
            .text{
                line-height: 28px;
                font-size: 16px;
                margin-top: 10px;
            }
            .button-box{
                margin-top: 30px;
                button{
                    cursor: pointer;
                    width: 76px;
                    height: 34px;
                    border-radius: 8px 8px 8px 8px;
                    margin: 0 20px;
                    box-sizing: border-box;
                }
                .cancel{
                    background: #FFFFFF;
                    border: 1px solid #E0E0E0;
                    color: #646464;
                }
                .confirm{
                    background: #5189F7;
                    color: #FFFFFF;
                }
            }
        }
    }
</style>
